import { cn } from "@/lib/cn";

/** Highlight colors offered in the editor. Stored as <mark data-color>
 *  (yellow = a plain <mark>, so older highlights stay yellow); each color
 *  has its own light and dark style below. */
export const HIGHLIGHT_COLORS = [
  { name: null, label: "Yellow", swatch: "bg-amber-200 dark:bg-amber-400/40" },
  { name: "green", label: "Green", swatch: "bg-emerald-200 dark:bg-emerald-400/40" },
  { name: "blue", label: "Blue", swatch: "bg-sky-200 dark:bg-sky-400/40" },
  { name: "pink", label: "Pink", swatch: "bg-pink-200 dark:bg-pink-400/40" },
  { name: "orange", label: "Orange", swatch: "bg-orange-200 dark:bg-orange-400/40" },
] as const;

/** Highlights: dark text on a light tint in light mode; a deeper,
 *  translucent tint with light text in dark mode (no glare). */
export const MARK_CLASS = cn(
  "[&_mark]:rounded-sm [&_mark]:px-0.5 [&_mark]:text-slate-900 [&_mark]:bg-amber-200",
  "dark:[&_mark]:bg-amber-400/30 dark:[&_mark]:text-amber-50",
  "[&_mark[data-color=green]]:bg-emerald-200 dark:[&_mark[data-color=green]]:bg-emerald-400/30 dark:[&_mark[data-color=green]]:text-emerald-50",
  "[&_mark[data-color=blue]]:bg-sky-200 dark:[&_mark[data-color=blue]]:bg-sky-400/30 dark:[&_mark[data-color=blue]]:text-sky-50",
  "[&_mark[data-color=pink]]:bg-pink-200 dark:[&_mark[data-color=pink]]:bg-pink-400/30 dark:[&_mark[data-color=pink]]:text-pink-50",
  "[&_mark[data-color=orange]]:bg-orange-200 dark:[&_mark[data-color=orange]]:bg-orange-400/30 dark:[&_mark[data-color=orange]]:text-orange-50",
);

/** Heading sizes that fit a card field (prose's defaults are page-sized). */
export const HEADING_CLASS =
  "prose-h1:mb-1 prose-h1:mt-3 prose-h1:text-xl prose-h2:mb-1 prose-h2:mt-3 prose-h2:text-lg prose-h3:mb-1 prose-h3:mt-2 prose-h3:text-base";

/** Inline images in rich text (editor and rendered): natural size up to
 *  the field's width, or the width they were resized to. In the editor
 *  the image is outlined while selected; resize handles are styled in
 *  index.css ([data-resize-handle]). */
export const IMAGE_CLASS = cn(
  "prose-img:my-1 [&_img]:inline-block [&_img]:h-auto [&_img]:max-w-full [&_img]:rounded-md [&_img]:border [&_img]:border-line",
  "[&_[data-resize-container]]:max-w-full [&_[data-resize-wrapper]]:max-w-full",
  "[&_.ProseMirror-selectednode_img]:ring-2 [&_.ProseMirror-selectednode_img]:ring-indigo-400",
);
